import axios from 'config/axios';

export default class DictionarySrv {
  static getBigStaticDictionaries() {
    return axios
      .get('dictionary/getBigStaticDictionaries')
      .then(result => result.data);
  }
}
